import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Add from '../../Icons/Add';

const styles = () => ({
  root: {
    border: '1px dashed #B1B3B9',
    boxSizing: 'border-box',
    height: '106px',
    margin: '10px 0px 50px 230px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#5A5B62',
    fontSize: '18px',
    cursor: 'pointer',
    '&:hover': {
      background: '#00000010',
    }
  },
});

class AddTimeline extends React.Component {
  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root} onClick={this.props.toggleAddStatusDialog}>
        <Add color="#5A5B62" width={24} height={24} />
        ステータスを追加
      </div>
    );
  }
}

AddTimeline.propTypes = {
  classes: PropTypes.object.isRequired,
  toggleAddStatusDialog: PropTypes.func,
};

export default withStyles(styles)(AddTimeline);



// WEBPACK FOOTER //
// ./src/components/Timeline/parts/AddTimeline.jsx